import { useSelector } from "react-redux";
import Icons from "../../assets/icon";
import { SmAnimatespin, Animatespin } from "../../components/index";

const JobTable = ({
  title,
  data,
  setValueJobslisting,
  setShowPopup,
  setFilterPopup,
  loadingapi,
  appliedJobsisLoading,
  requestTitle,
  loading,
  loadingapplyapi,
  handleApplyJob,
  savedJobs,
  isLoading,
  formatDate,
  handleSevedJob,
  setApprovedRequests,
  setPopupApprovedRequests,
  handleStartChat,
}) => {
  const userData = useSelector((state) => state.app.userData.userData);
  return (
    <div
      className={`overflow-x-scroll ${
        isLoading || appliedJobsisLoading || data?.length < 1
          ? "scroll-container"
          : "dashboard-custom-scrollbar"
      }`}
    >
      {isLoading || appliedJobsisLoading ? (
        <Animatespin />
      ) : (
        <>
          {data?.length > 0 ? (
            <div className="w-full">
              <div className="grid grid-cols-11 lg:min-w-[1600px] h-full sm:min-w-[1200px] xs:min-w-[900px] text-secondary bg-[#1A1A1A] px-5 pb-3 xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                {title.map((value, index) => (
                  <div
                    key={index}
                    className={`flex items-center xs:gap-x-2 sm:gap-x-2.5 ${
                      index === title.length - 1 ? "justify-center" : ""
                    }`}
                  >
                    {value}
                    {/* <img
                      src={Icons.tableTitleIcon}
                      alt="chat"
                      className={`xs:w-3 xs:h-3 sm:w-3 sm:h-3 lg:w-4 lg:h-4 xl:w-5 xl:h-5 ${
                        index === title.length - 1 ? "hidden" : "block"
                      }`}
                    /> */}
                  </div>
                ))}
              </div>
              <div className="">
                {data?.map((job, index) => (
                  <div
                    key={index}
                    className={`grid grid-cols-11 lg:min-w-[1600px] sm:min-w-[1200px] xs:min-w-[900px] text-secondary cursor-pointer rounded-lg my-4 px-5 py-4 gap-3 items-center ${
                      index % 2 === 0 ? "bg-[#2A2A2A]" : "bg-transparent"
                    }`}
                    onClick={() => {
                      setValueJobslisting(job);
                      setShowPopup(true);
                      setFilterPopup(false);
                    }}
                  >
                    {job?.job ? (
                      <>
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          {job?.job?.title}
                        </div>
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          {job?.job?.job_types?.job_type}
                        </div>
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          {job?.job?.country?.country}
                        </div>
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          {job?.job?.state?.state}
                        </div>
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          {job?.job?.city?.city}
                        </div>
                        {/* <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">{job?.job?.postal_code}</div> */}
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          <p
                            className="truncate line-clamp-1"
                            dangerouslySetInnerHTML={{
                              __html: job?.job?.description,
                            }}
                          />
                        </div>
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          <p
                            className="truncate line-clamp-1"
                            dangerouslySetInnerHTML={{
                              __html: job?.job?.benefits,
                            }}
                          />
                        </div>
                        {/* <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">{job?.job?.job_experience?.job_experience}</div> */}
                        {/* <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">{job?.job?.job_shift}</div> */}
                        {/* <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">{job?.job?.gender}</div> */}
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          {formatDate(job?.job?.expiry_date)}
                        </div>
                        {/* <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">{job?.job?.degreeLevel}</div> */}
                        {job?.job?.hide_salary ? (
                          <div className="w-9/12 h-px bg-white"></div>
                        ) : (
                          <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                            {job?.job?.salary_currency ?? ""}{" "}
                            {job?.job?.salary_from}-{job?.job?.salary_to}
                          </div>
                        )}
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          {job?.job?.num_of_positions}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          {job?.title}
                        </div>
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          {job?.job_types?.job_type}
                        </div>
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          {job?.country?.country}
                        </div>
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          {job?.state?.state}
                        </div>
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          {job?.city?.city}
                        </div>
                        {/* <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">{job?.postal_code}</div> */}
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          <p
                            className="truncate line-clamp-1"
                            dangerouslySetInnerHTML={{
                              __html: job?.description,
                            }}
                          />
                        </div>
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          <p
                            className="truncate line-clamp-1"
                            dangerouslySetInnerHTML={{ __html: job?.benefits }}
                          />
                        </div>
                        {/* <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">{job?.job_experience?.job_experience}</div> */}
                        {/* <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">{job?.job_shift}</div> */}
                        {/* <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">{job?.gender}</div> */}
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          {formatDate(job?.expiry_date)}
                        </div>
                        {/* <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">{job?.degreeLevel}</div> */}
                        {job?.hide_salary ? (
                          <div className="w-9/12 h-px bg-white"></div>
                        ) : (
                          <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                            {job?.salary_currency ?? ""} {job?.salary_from}-
                            {job?.salary_to}
                          </div>
                        )}
                        <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                          {job?.num_of_positions}
                        </div>
                      </>
                    )}

                    <div className=" xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                      {job?.status ? (
                        <div className=" flex items-center justify-center gap-x-1">
                          {job?.status === "Accepted" && (
                            <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular flex items-center justify-center">
                              <div
                                className="bg-[#787878] xs:w-5 xs:h-5 sm:w-6 sm:h-6 lg:w-7 lg:h-7 xl:w-8 xl:h-8 flex justify-center items-center rounded-full cursor-pointer"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  handleStartChat(
                                    job?.job?.company?.user_id,
                                    userData?.talent?.user_id
                                  );
                                }}
                              >
                                {loading ? (
                                  <SmAnimatespin />
                                ) : (
                                  <img
                                    src={Icons.chatIcon}
                                    alt="chat"
                                    className="xs:w-3 xs:h-3 sm:w-3 sm:h-3 lg:w-4 lg:h-4 xl:w-[18px] xl:h-[18px]"
                                  />
                                )}
                              </div>
                            </div>
                          )}
                          <div
                            className={` bg-[#787878] xs:p-1.5 sm:px-3 sm:py-1.5 lg:px-4 lg:py-2 rounded-full cursor-pointer ${
                              job?.status === "Accepted"
                                ? "text-accepted"
                                : job?.status === "Pending"
                                ? "text-pending"
                                : job?.status === "Saved"
                                ? "text-pending"
                                : "text-rejected"
                            }`}
                          >
                            <p className="xs:text-[10px] sm:text-xs lg:text-sm truncate font-onestRegular">
                              {job?.status}
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div className=" flex items-center justify-center gap-2">
                          <div
                            className="flex justify-center items-center rounded-full xs:w-5 bg-[#787878] xs:h-5 sm:w-6 sm:h-6 lg:w-8 lg:h-8"
                            onClick={(event) => {
                              event.stopPropagation();
                              handleSevedJob(job?.id, job?.is_job_saved);
                            }}
                          >
                            {loadingapi === job?.id ? (
                              <div className="animate-spin rounded-full border-t-2 border-b-2 border-secondary w-6 h-6"></div>
                            ) : job?.is_job_saved ? (
                              <img
                                src={Icons.dasSavedIcon}
                                className="xs:w-3.5 xs:h-3.5 sm:w-4 sm:h-4 lg:w-5 lg:h-5"
                                alt="MdOutlineStar"
                              />
                            ) : (
                              <img
                                src={Icons.dasSaveIcon}
                                className="xs:w-2.5 xs:h-2.5 sm:w-3 sm:h-3 lg:w-4 lg:h-4"
                                alt="MdOutlineStarBorder"
                              />
                            )}
                          </div>
                          <button
                            className={`text-accepted bg-[#787878] xs:p-1.5 sm:px-3 sm:py-1.5 lg:px-4 lg:py-2 rounded-full ${
                              job?.is_job_applied
                                ? "cursor-not-allowed opacity-55"
                                : "cursor-pointer"
                            }`}
                            onClick={(event) => {
                              event.stopPropagation();
                              handleApplyJob(job?.id, userData?.talent?.id);
                            }}
                            type="submit"
                            disabled={job?.is_job_applied}
                          >
                            {loadingapplyapi === job?.id ? (
                              <div className="animate-spin rounded-full border-t-2 border-b-2 border-secondary w-6 h-6"></div>
                            ) : (
                              <p className="xs:text-[10px] sm:text-xs lg:text-sm truncate font-onestRegular text-accepted">
                                {job?.is_job_applied ? "Applied" : "Apply"}
                              </p>
                            )}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div>
              <p className="text-secondary capitalize text-center">
                No {requestTitle} available.
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default JobTable;
